export const i18n: any = {
    en: {
        title: 'Stay in Charge with Smart Power',
        desc: 'Monitor, control, and customize your power usage intelligently with the EcoFlow app.',
        item1_subtitle: 'Monitor',
        item1_title: 'Real-time energy insights on the go.',
        item1_desc: 'View battery status live anytime, anywhere.',
        item2_subtitle: 'Control',
        item2_title: 'Control even from afar.',
        item2_desc: 'Easily turn on/off output and the connected appliances remotely.',
        item3_subtitle: 'Constant Updates',
        item3_title: 'Constant updates for optimal user experience.',
        item3_desc: 'Regular upgrades to offer you industry-leading energy management.',
        list1_subtitle: 'Customize',
        list1_title: 'Save more on electricity bills.',
        list1_desc:
            "Optimize your home's energy use and reduce energy bills by smartly leveraging power from the sun, grid, and batteries during peak and off-peak hours.",
        list2_subtitle: '',
        list2_title: 'Stay calm and powered on.',
        list2_desc:
            "When the power's down, AC Always-On ensures a seamless transition from the grid to backup power and unwavering protection of your fridge and other mission-critical appliances.",
        list3_subtitle: '',
        list3_title: 'Elevated battery lifespan and safety.',
        list3_desc: "By tuning the charging speed to suit various charging environments, it's safe to use, preventing overloading and prolonging its lifespan.",
        tip: 'Download the EcoFlow app',
    },
    mx: {
        title: 'Manténgase al mando con Smart Power',
        desc: 'Supervise, controle y personalice su consumo de energía de forma inteligente con la aplicación EcoFlow.',
        item1_subtitle: 'Supervise',
        item1_title: 'Información energética en tiempo real sobre la marcha.',
        item1_desc: 'Vea el estado de la batería en directo en cualquier momento y lugar.',
        item2_subtitle: 'Control',
        item2_title: 'Control incluso desde lejos.',
        item2_desc: 'Encienda y apague fácilmente la salida y los aparatos conectados de forma remota.',
        item3_subtitle: 'Actualizaciones constantes',
        item3_title: 'Actualizaciones constantes para una experiencia de usuario óptima.',
        item3_desc: 'Actualizaciones periódicas para ofrecerle una gestión energética líder en el sector.',
        list1_subtitle: 'Personalice',
        list1_title: 'Ahorre más en la factura de la luz.',
        list1_desc:
            'Optimice el uso de la energía de su hogar y reduzca las facturas de electricidad aprovechando de forma inteligente la energía del sol, la red y las baterías durante las horas punta y las horas valle.',
        list2_subtitle: '',
        list2_title: 'Mantenga la calma y la energía.',
        list2_desc:
            'Cuando se va la luz, AC Always-On garantiza una transición sin problemas de la red a la energía de reserva y una protección inquebrantable de su frigorífico y otros aparatos críticos.',
        list3_subtitle: '',
        list3_title: 'Mayor vida útil y seguridad de la batería.',
        list3_desc:
            'Al ajustar la velocidad de carga para que se adapte a los distintos entornos de carga, su uso es seguro, se evita la sobrecarga y se prolonga su vida útil.',
        tip: 'Descargue la aplicación EcoFlow',
    },
};
